export default "__VITE_ASSET__DqBqq49v__"